var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "entry-layout",
      staticStyle: { height: "100vh", "min-width": "1200px" }
    },
    [
      _c(
        "entry-layout-header",
        {
          attrs: {
            menus: _vm.menus,
            customTabs: _vm.customTabs,
            customMenus: _vm.customMenus,
            menusActiveID: _vm.menusActiveID,
            currentLang: _vm.currentLang,
            subjectMode: _vm.subjectMode
          },
          on: {
            menusadd: _vm.handleAddCustomMenus,
            menuschange: _vm.handleMenusChange,
            menuchange: _vm.handleMenuChange,
            custommenu: _vm.handleEditCustomMenus
          }
        },
        [_vm._t("rightContentRender", null, { slot: "rightContentRender" })],
        2
      ),
      _c(
        "section",
        { staticClass: "entry-layout entry-layout--has-sider" },
        [
          _c("entry-sider", {
            attrs: {
              menus: _vm.menus,
              customMenus: _vm.customMenus,
              menusActiveID: _vm.menusActiveID,
              panesHistory: _vm.panesHistory,
              currentLang: _vm.currentLang,
              unfold: _vm.unfold
            },
            on: {
              menusadd: _vm.handleAddCustomMenus,
              menusremove: _vm.handleRemoveCustomMenus,
              menuschange: _vm.handleMenusChange,
              menuchange: _vm.handleMenuChange,
              menupushpin: _vm.handleMenuPushpin
            }
          }),
          _c(
            "section",
            { staticClass: "entry-layout" },
            [
              _c("entry-multi-tab", {
                attrs: {
                  panes: _vm.panes,
                  activeKey: _vm.activeKey,
                  currentLang: _vm.currentLang
                },
                on: { change: _vm.handleMenuChange }
              }),
              _c("entry-layout-content", [_vm._t("default")], 2)
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }